import dayjs from 'dayjs';
import { CHART_TITLE_HORAS_FRIO_ACUMULADAS } from '../../../../constants/graphs';

export interface URLParams {
  farmId: string;
  sectorId: string;
}

export interface ColdHoursChartProps {
  chartView: 'dashboard' | 'graphs' | 'settings' | 'fullScreen';
  sectorId: string;
  farmId: string;
  hideLegend?: boolean;
  hideXValues?: boolean;
  hideYValues?: boolean;
  hideRightYAxisTitle?: boolean;
  height?: number | string;
  title?: string;
  yAxisTitle?: string;
  refreshKey?: number;
  config?: ColdHoursConfigType;
  isWeatherStation?: boolean;
}

export interface ColdHoursConfigType {
  accumulatedDegreesBaseTemp: number;
  accumulatedDegreesStartMonth: number;
  accumulatedDegreesStartDay: number;
  accumulatedDegreesEndMonth: number;
  accumulatedDegreesEndDay: number;
  coldHoursBaseTemp: number;
  coldHoursStartMonth: number;
  coldHoursStartDay: number;
  coldHoursEndMonth: number;
  coldHoursEndDay: number;
}

export interface ChartResult {
  series: Array<{
    type: string;
    name: string;
    data: Array<{
      x: number;
      y: number | null;
      custom: {
        date: string;
        realValue?: number;
      };
    }>;
    connectNulls?: boolean;
  }>;
  absoluteCategories: string[];
  hideYValues: boolean;
}

export interface DailyReading {
  min: number;
  max: number;
}

export interface DateRange {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
}

export const DEFAULT_COLD_HOURS_CONFIG = {
  coldHoursBaseTemp: 10,
  accumulatedDegreesBaseTemp: 10,
  coldHoursStartMonth: 4,
  coldHoursStartDay: 1,
  coldHoursEndMonth: 9,
  coldHoursEndDay: 30,
  accumulatedDegreesStartMonth: 4,
  accumulatedDegreesStartDay: 1,
  accumulatedDegreesEndMonth: 9,
  accumulatedDegreesEndDay: 30,
};

export const DEFAULT_CHART_PROPS = {
  height: 600,
  title: CHART_TITLE_HORAS_FRIO_ACUMULADAS,
  yAxisTitle: 'Horas Frío Acumuladas',
  hideLegend: false,
  hideXValues: false,
  hideYValues: false,
};
